<script setup>
import { h, isVNode } from 'vue';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
});

const TABLER_FORWARD_ICON = 'i-tabler-corner-up-right-double';

const renderIcon = () => {
  if (!props.icon) return null;
  if (typeof props.icon === 'function' || isVNode(props.icon)) {
    return props.icon;
  }
  if (props.icon === TABLER_FORWARD_ICON) {
    return h(
      'svg',
      {
        width: '1.25em',
        height: '1.25em',
        viewBox: '0 0 82 60',
        fill: 'none',
        stroke: 'currentColor',
        'stroke-width': '8',
        'stroke-linecap': 'round',
        'stroke-linejoin': 'round',
        class: 'max-h-5 max-w-5 flex-shrink-0 text-black',
        'aria-hidden': 'true',
        focusable: 'false',
      },
      [
        h('path', { d: 'M4 54V44c0-11 9-20 20-20h33' }),
        h('path', { d: 'm37 4 20 20-20 20' }),
        h('path', { d: 'm57 4 20 20-20 20' }),
      ]
    );
  }
  return h('span', { class: props.icon });
};
</script>

<template>
  <component :is="renderIcon" />
</template>
